import React, { Component } from "react";
import Footer from './content/Footer';
import WebfineryNavbar from './WebfineryNavbar';
import { Button, Tabs, Tab, Grid, Col, Row } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import Helmet from 'react-helmet';
import Feature from './content/Feature';
import InnerFeature from './content/InnerFeature';
import UserCondition from './UserCondition';
import ApiKeyDashboard from './api/ApiKeyDashboard';
import ApiCallDashboard from './api/ApiCallDashboard';
import StripeDashboard from './stripe/StripeDashboard';
import { browserHistory } from 'react-router';
import InnerFeatureButtonGroup from './content/InnerFeatureButtonGroup';
import Hero from './content/Hero';
import ContactModal from './ContactModal';
import cookie from 'react-cookie';

class DashboardPage extends Component {

	constructor() {
		super();
		this.state = { fa: "", contactModalVisible: false, contactModalTopic: "", contactModalMessage: "", contactModalCue:"", contactModalPush: "" };
		this.handleLogout = this.handleLogout.bind(this);
		this.handleShowContactUs = this.handleShowContactUs.bind(this);
		this.handleHideContactUs = this.handleHideContactUs.bind(this);
	}

	componentWillMount() {
		if (!cookie.load('webfinery.jwt')) {
			browserHistory.push("/login?reason=403");
		}
	}

    handleLogout() {
    	browserHistory.push("/logout", { } );    	
    }

	handleShowContactUs() {
		this.setState({contactModalVisible: true, fa: "fa-envelope-open-o", contactModalTopic: "Upgrade Request", 
			contactModalCue: "Webfinery Services",
			contactModalPush: "Please specify your requirements",
			messageInputCollapsed: false
		});
	} 

   	handleHideContactUs() {
		this.setState({contactModalVisible: false});	
	}

	handleModalToggle() {
		this.setState = { modalToggle: !this.state.modalToggle };
	}

    render() {
        return (
            <div>
            	<Helmet title="Dashboard"/>

            	<UserCondition isLoggedIn={true}>
                
                <WebfineryNavbar/>
                
            	<div className="dashboardContent">

	            	<Grid>
	            		<Col span={12}>
	            			<Row className="text-center">
	            				<h1>Dashboard</h1>
	            			</Row>
	            		</Col>
	            		<Col span={12}>
	            			<Row>

				            	<Tabs bsStyle="tabs" defaultActiveKey={1} justified>
								  <Tab eventKey={1} title="Services">

							      		<Feature>
							      				<h5><i className="fa fa-cog fa-3x" aria-hidden="true"></i></h5>
							  					<h4>Webfinery Services</h4>
							  					<h5>You have currently 2 active services</h5>
							      		</Feature>

							      		<InnerFeature label="Search" small="Basic Plan (Free)">
							      			Search the source code of the web. Make a list of websites. 		      			
							      			<InnerFeatureButtonGroup>							
							      				<Button bsSize="sm" onClick={this.handleShowContactUs}>Upgrade</Button>
							      				<LinkContainer to="/search">
							      					<Button bsStyle="success" bsSize="sm">Search UI</Button>
							      				</LinkContainer>
							      			</InnerFeatureButtonGroup>
							      		</InnerFeature>
							      		<InnerFeature label="Visit Rank API" small="Basic Plan (Free)">
							      			Get a rank for any of 385 million web domains. User the API.
							      			<InnerFeatureButtonGroup>							
						      					<Button bsSize="sm" onClick={this.handleShowContactUs}>Upgrade</Button>
							      				<LinkContainer to="/cloud/visitrank">
							      					<Button bsStyle="success" bsSize="sm">API docs &amp; pricing</Button>
							      				</LinkContainer>
							      			</InnerFeatureButtonGroup>		      			
							      		</InnerFeature>
							      		<Feature>
							      			<h4>More services</h4>
							      			<h5>Contact us to request access to any other Webfinery services</h5>
							      			<LinkContainer to="/cloud">
							      				<Button>All cloud services</Button>
							      			</LinkContainer>
							      		</Feature>

								  </Tab>


								  <Tab eventKey={2} title="API Access">

						     		<Feature>
											<h5><i className="fa fa-key fa-3x" aria-hidden="true"></i></h5>
						  					<h4>Your secret API keys</h4>
						  					<h5>API keys are like passwords. Don't share them. Keep them safe.</h5>
							   				<ApiKeyDashboard/>
							   		</Feature>

							   		<Feature>
										<h5><i className="fa fa-bar-chart fa-3x" aria-hidden="true"></i></h5>
					  					<h4>Visit Rank API Calls</h4>
					  					<h5>Past 30 days</h5>
							   			<ApiCallDashboard/>
							   		</Feature>
								  
								  </Tab>


								  <Tab eventKey={3} title="Payment">
						   			<Feature>
										<h5><i className="fa fa-credit-card-alt fa-3x" aria-hidden="true"></i></h5>			   			
						   				<h4>Payment Details</h4>
						   				You will receive an email <strong>3 days before</strong> we make the actual charge.<br />
						   				<StripeDashboard/>
						   			</Feature>		   		
								  </Tab>

									<Tab eventKey={4} title="Session">
							     		<Feature>
											<h5><i className="fa fa-user fa-3x" aria-hidden="true"></i></h5>
						  					<h4>END THIS SESSION</h4>
						  					<br />
							  				<Button className="text-center" onClick={this.handleLogout}>Log out</Button>
								   		</Feature>
									</Tab>

								</Tabs>
	            			</Row>
	            		</Col>
	            	</Grid>

	            </div>                
                </UserCondition>

    			<ContactModal fa={this.state.fa} topic={this.state.contactModalTopic} message={this.state.contactModalMessage} 
    				contactModalCue={this.state.contactModalCue} contactModalPush={this.state.contactModalPush} 
    				visible={this.state.contactModalVisible} handleHide={this.handleHideContactUs}     				
    				messageInputCollapsed={this.state.messageInputCollapsed} />    			

                <Footer/>


            </div>
        );
    }
}

export default DashboardPage;



// WEBPACK FOOTER //
// ./src/DashboardPage.js